{
    "demographics": {
        "language": {
            "en-US": "English (United States)",
            "es-ES": "Spanish (Spain)",
            "es-US": "Spanish (United States)"
        },
        "proficiency": {
            "native": "Native",
            "fluent": "Fluent",
            "not-native-or-fluent": "Not native or fluent"
        },
        "hispanic": {
            "no": "Not Hispanic or Latino/a",
            "yes": "Hispanic or Latino/a",
            "unknown": "Unknown"
        },
        "age": "{{age, number}} y.o.",
        "gender": {
            "male": "Male",
            "female": "Female",
            "other": "Other"
        },
        "education": {
            "didnt_complete_high_school": "Did not complete high school or upper secondary education",
            "high_school": "Completed high school or upper secondary education",
            "upper_secondary": "Some post upper secondary education after completing high school or upper secondary education",
            "bachelors_degree": "Completed bachelor’s degree or equivalent",
            "masters_degree": "Completed master’s degree, equivalent or higher"
        },
        "races": {
            "american_indian_or_alaska_native": "American Indian or Alaska Native",
            "asian": "Asian",
            "african_american": "Black or African American",
            "hawaiian_or_other_islander": "Native Hawaiian or other Pacific Islander",
            "white": "White",
            "other": "Other",
            "asian_or_asian_british": "Asian or Asian British",
            "black_black_british_carribean_or_afrikan": "Black, Black British, Carribean or African",
            "mixed_or_multiple_groups": "Mixed or multiple ethnic groups"
        }
    }
}
